import { render } from "./DefaultStringControlRenderer.vue?vue&type=template&id=2fe49bda&ts=true"
import script from "./DefaultStringControlRenderer.vue?vue&type=script&lang=ts"
export * from "./DefaultStringControlRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__